

export class ExpenseCategoryDto implements IExpenseCategoryDto {
    id!: number;
    categoryName!: string | undefined;
    isSystemDefined!: boolean;
    isActive!: boolean;

    constructor(data?: IExpenseCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryName = _data["categoryName"];
            this.isSystemDefined = _data["isSystemDefined"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ExpenseCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryName"] = this.categoryName;
        data["isSystemDefined"] = this.isSystemDefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IExpenseCategoryDto {
    id: number;
    categoryName: string | undefined;
    isSystemDefined: boolean;
    isActive: boolean;
}

